import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F10.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame10() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);

    if (isLoading === true) {
        return (<div className="F9_image"></div>)
    } else {
        return (
            <div className="F10_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F10_entryBox">
                    <div className="F10_paragraph">
                        {language === 'english' ?
                            <p className="F10_paragraphEnglish">Saira also recalls that Maria discussed her experience only because Saira had consoled her after other girls had made fun of Maria when they saw bloodstains on her clothes</p>
                            :
                            <p className="F10_paragraphUrdu">سائرا کو یہ بھی یاد آرہا ہے کہ ماریہ نے اسے اپنی ماہواری کےبارے میں صرف اس لئے بتایا تھا کیونکہ سائرا نے ماریہ کو تسلی دی تھی جب کہ دوسری لڑکیاں ماریہ کے کپڑوں پر خون کے دھبے دیکھ کر اس کا مزاق اڑا رہی تھیں۔</p>
                        }
                    </div>

                    <div className="F10_timeline">
                        <div className='F10_timelineBar'>
                            <div className='F10_timelineFill'></div>
                            <span className='F10_timelineText'>8/16</span>
                        </div>
                    </div>

                    <div className="F10_nextFrames">
                        <div className="F10_nextFrame1"></div>
                        <div className="F10_nextFrame2"></div>
                        <div className="F10_nextFrame3"></div>
                    </div>

                    <div className='F10_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(8)) }} className='F10_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame10;